import { SiteMapData } from '../SiteMap';
import SiteMapMenuGroup from './site-map-menu-group-row/SiteMapMenuGroup';

/**
 * SiteMapHeaderRow Component
 * Displays the MenuGroups Columns in a Row
 * It is a separate component because we have to handle in appearance if the header text breaks into two lines
 */
const SiteMapMenuGroupRow: React.FC<{
	siteMapRowData: SiteMapData[];
	numOfCols: number;
	startIndex?: number;
}> = ({ siteMapRowData, numOfCols = 0, startIndex = 0 }) => {
	return (
		<div className="site-map-menu-group-row">
			{siteMapRowData.map((siteMapColumn, i) => (
				<div key={i} className={`site-map-col-${numOfCols}`}>
					<ul
						className="site-map-column-menu-group-container"
						aria-labelledby={`site-map-column-${startIndex + i}-heading`}
					>
						{siteMapColumn.menuGroups.map((menuGroup) => (
							<SiteMapMenuGroup key={menuGroup.name} menuGroup={menuGroup} />
						))}
					</ul>
				</div>
			))}
		</div>
	);
};

export default SiteMapMenuGroupRow;
